export default {"src":"/_next/static/media/social-fb.0e1ba823.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};